import gql from "graphql-tag"

export default gql`
    mutation updatePromoCode($promoCodeUid: String!, $promoCode: PromoCodeUpdateInput!) {
    updatePromoCode(promoCodeUid: $promoCodeUid, promoCode: $promoCode){
        statusCode
        message
        result{
            id
            uid
            code
            platformType
            serviceType
            flight{
                airlines
                originAirportCodes
                destinationAirportCodes
                applyOn
            }
            type
            amount
            usage{
                limit
                limitType
                counter
            }
            validityFrom
            validityTo
            description
            isActive
            inActiveNote
            createdAt
            updatedAt
        }
    }
}
`